var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dis",staticStyle:{"margin-top":"200px","flex-direction":"column"}},[_c('img',{attrs:{"src":require("../assets/404.png")}}),_c('div',{staticStyle:{"cursor":"pointer","margin-top":"30px","color":"#666","text-align":"center"},on:{"click":_vm.go}},[_vm._v("回到登录页")])])
}
var staticRenderFns = []

export { render, staticRenderFns }